import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
// Initialize i18n
import "./lib/i18n";

// Temporarily disable StrictMode to avoid WebSocket double-mount issues in dev
// TODO: Re-enable after properly handling cleanup/reconnection in ColyseusProvider
createRoot(document.getElementById("root")).render(
  // <StrictMode>
  <App />
  // </StrictMode>
);
